import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-modal';
import moment from 'moment';
import { getEFSList, getEmptyEFS, getEFS, getLoadDetails, getLoadNotes, setLoadNote, setEmptyAllNotes } from '../../../../../store/actions/callCheckLoadsActions/callCheckLoads';
import { Input } from 'antd';
import { CallCheckLoadsSelectors } from '../../../../../store/selectors/callCheckLoadsSelectors';
import { getColorClass } from './helper';
import Loading from '../../../screen/loading';
import { customStyleEFS, customStylesEFSListModal } from './styles';
import EFSModal from './EFSModal';
import './index.css';
const { TextArea } = Input;

const EFSListModal = ({ setEFSListModalIsOpen, EFSListModalIsOpen, rowState, page, resource, loadType }) => {
  const dispatch = useDispatch();
  const { EFSLoading, EFSList, EFSData, loadNotes } = CallCheckLoadsSelectors();
  const [ EFSModalIsOpen, setEFSModalIsOpen ] = useState(false);
  const [ isEditMode, setEditMode ] = useState(false);
  let loadId = '';
  if (rowState.type === 'stop') {
    loadId = rowState.loadId;
  } else if (rowState.type === 'load') {
    loadId = rowState.id;
  };

  const closeModal = () => {
    setEFSListModalIsOpen(false);
    dispatch(getLoadDetails(resource, loadId, page))
  };

  useEffect(() => {
    dispatch(getEFSList('LoadEFS', loadId));
    
  }, [dispatch, loadId]);
  const handleEFSOpen = (editMode, efsId) => {
    if (editMode === 'editMode') {
      setEditMode(true);
      dispatch(getEFS('loadEFS', efsId));
    } else {
      setEditMode(false);
      dispatch(getEmptyEFS('loadEFS'));
    }
    setEFSModalIsOpen(true);
  };

  useEffect(() => {
      dispatch(getLoadNotes(resource, rowState, loadType));
  }, [dispatch, loadType, resource, rowState]);

  useEffect(() => {
    return () => {
      dispatch(setEmptyAllNotes(resource));
    };
  }, [dispatch, resource]);

  const [newNote, setNewNote] = useState('');

  const saveNote = () => {
    dispatch(setLoadNote(resource, rowState, newNote, loadType));
    setNewNote('');
  };

  const getLoadStatusNameById = id => {
    const statusesList = {
      0: '-',
      1: 'Ready to be Picked Up',
      2: 'In Transit',
      3: 'Delivered',
      4: 'Delayed',
    };
    return statusesList?.[id];
  };

  if (EFSLoading) {
    return (
      <Modal isOpen={EFSListModalIsOpen} style={customStyleEFS}>
        <div style={{ marginTop: '30% ' }}>
          <Loading />
        </div>
      </Modal>
    );
  }

  return (
    <Modal isOpen={EFSListModalIsOpen} onRequestClose={closeModal} style={customStylesEFSListModal} ariaHideApp={false}>
      <>
        <>
        <div className='comment_modal__x-btn' onClick={closeModal}>X</div>
          <div className='comment_modal_text'>Notes</div>
          <table className='comment-modal__table'>
            <thead>
              <tr className='comment-modal__tr'>
                <th className='comment-modal__th'>Status</th>
                <th className='comment-modal__th'>Comments</th>
                <th className='comment-modal__th'>Date and Time</th>
                <th className='comment-modal__th'>Created By</th>
              </tr>
            </thead>
            {loadNotes?.data?.length
              ? loadNotes?.data?.map(note => (
                  <tr className='comment-modal__tr' key={note?.id}>
                    <td className='comment-modal__td'>{getLoadStatusNameById(note?.stopStatus)}</td>
                    <td className='comment-modal__td'>{note?.comment}</td>
                    <td className='comment-modal__td'>{moment(note?.createDate).format('MM/DD/YY HH:mm')}</td>
                    <td className='comment-modal__td'>{note?.user}</td>
                  </tr>
                ))
              : null}
          </table>
          <div className='add-comment__container'>
            <div className='add_new_comment'>Add new note</div>
            <TextArea
              placeholder='Add new note'
              autoSize={{ minRows: 2, maxRows: 6 }}
              className='reject-reason__input'
              status={'error'}
              onChange={e => setNewNote(e.target.value)}
              value={newNote}
            />
          </div>
          <div className='commnet__add-btn__container'>
            <button disabled={!newNote} className={`${!newNote && 'disabled__add-btn'} comment-modal-button`} type='submit' onClick={saveNote}>
              Add
            </button>
          </div>
        </>
      
        <div className='comment_modal__container'>
          <div className='modal_formik_container'>
            <div className='efs-modal__title'>EFS Modal</div>
            <div className='add-btn__container'>
              <div className='efs-add__btn' onClick={() => handleEFSOpen(false)}>Add EFS</div>
            </div>
            <div className='efs-table__container'>
              <table className='efs-modal__table'>
                <tr className='efs-modal__tr efs-modal__tr-th'>
                  <th className='efs-modal__th'>Payment method</th>
                  <th className='efs-modal__th'>Amount</th>
                  <th className='efs-modal__th'>Card Number</th>
                  <th className='efs-modal__th'>Note</th>
                  <th className='efs-modal__th'>EFS Status</th>
                  <th className='efs-modal__th efs-modal__actions'>Actions</th>
                </tr>
                {EFSList?.data?.length ? (
                  EFSList.data.map(efs => (
                    <tr className='efs-modal__tr' key={efs.id}>
                      <td className='efs-modal__td'>{efs.paymentMethod}</td>
                      <td className='efs-modal__td'>${efs.amount}</td>
                      <td className='efs-modal__td'>{efs.cardNumber}</td>
                      <td className='efs-modal__td'>{efs.note}</td>
                      <td className={`efs-modal__td ${getColorClass(efs.efsStatus)} `}>{efs.efsStatusStr}</td>
                      <td className='efs-modal__td efs-modal__actions' onClick={() => handleEFSOpen('editMode', efs.id)}>
                        <div className='button micro efs-action load-details__action-btn'>
                          <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path
                              d='M11.1965 6.02L12.1165 6.94L3.05647 16H2.13647V15.08L11.1965 6.02ZM14.7965 0C14.5465 0 14.2865 0.1 14.0965 0.29L12.2665 2.12L16.0165 5.87L17.8465 4.04C18.2365 3.65 18.2365 3.02 17.8465 2.63L15.5065 0.29C15.3065 0.09 15.0565 0 14.7965 0ZM11.1965 3.19L0.136475 14.25V18H3.88647L14.9465 6.94L11.1965 3.19Z'
                              fill='#3C8680'
                            />
                          </svg>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className='efs-modal__tr' style={{ height: '24px' }}>
                    <td className='efs-modal__td'></td>
                    <td className='efs-modal__td'></td>
                    <td className='efs-modal__td'></td>
                    <td className='efs-modal__td'></td>
                    <td className='efs-modal__td'></td>
                    <td className='efs-modal__td efs-modal__actions'></td>
                  </tr>
                )}
              </table>
            </div>
          </div>
        </div>

        {EFSModalIsOpen && (
          <EFSModal
            EFSModalIsOpen={EFSModalIsOpen}
            setEFSModalIsOpen={setEFSModalIsOpen}
            EFSData={EFSData}
            EFSLoading={EFSLoading}
            loadId={loadId}
            isEditMode={isEditMode}
          />
        )}
      </>
    </Modal>
  );
};

export default EFSListModal;
